export default __webpack_public_path__ + "static/media/palvelut-lightblue.6326ad79.svg";